import { SearchResult } from './search-result';
import { Modalable, ResponseStatus } from './modalable';
import { Worksheet } from './worksheet';

export class HomeworkLink implements Modalable {
    static MODAL_ID = 'homework-Modal';
    id: string | number;
    title: string;
    link: string;
    domain: string;
    email: string;
    secondEmail: string;
    qrCode: string;
    correctionLink: string;
    downloadLink: string;
    bypassCheck = false;
    created: number;
    updated: number;
    selectedForDeletion = false;
    status: ResponseStatus;
    test: boolean;
    cooldownPhase: number | null = null;
    printLink: string;

    exercises: Array<SearchResult>;
    worksheet: null|Worksheet

    constructor() {
        this.exercises = [];
    }

    getStatus(): ResponseStatus {
        return this.status;
    }

    getModalId(): string {
        return HomeworkLink.MODAL_ID;
    }

    canBypassCheck(): boolean {
        return this.bypassCheck;
    }

    castNumberToTwoDigitString(value: number): string {
        if (value < 10) {
            return `0${value}`;
        }

        return `${value}`;
    }

    getLink(): string {
        return `https://${this.domain}/${this.link}`;
    }

    getTitle(): string {
        return this.title
    }
}
